import {Admin, CustomRoutes, Resource} from 'react-admin';
import {Route} from 'react-router-dom';
import {UserEdit, UserList, UserShow} from './pages/users';
import {dataProvider} from "./utils/data-provider";
import {authProvider} from "./pages/auth/authProvider";
import LoginPage from "./pages/auth/LoginPage";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import SuggestionsPage from "./pages/wines/SuggestionsPage";
import {CustomLayout} from "./custom-ui/CustomLayout";
import {wineohTheme} from "./theme";

function App() {
  return (
    <Admin
      dataProvider={dataProvider}
      authProvider={authProvider}
      loginPage={LoginPage}
      theme={wineohTheme}
      layout={CustomLayout}
    >
      <Resource
        name="admin/users"
        options={{label: 'Users'}}
        list={UserList}
        edit={UserEdit}
        show={UserShow}
      />
      <CustomRoutes>
        <Route path="/wine-suggestions" element={<SuggestionsPage />} />
      </CustomRoutes>
      <CustomRoutes noLayout>
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </CustomRoutes>
    </Admin>
  );
}

export default App;
